// ─────────────────────────────────────────────────────────────────────────────
// CACHE1 — kujtesa e telefonit për leximin pa internet (7 shtator 2026)
//
// PSE. Pa internet aplikacioni s'hapej fare: çdo nisje pyeste serverin nga zero
// dhe, kur ai s'përgjigjej, personat vendoseshin `{}` dhe pema dilte bosh.
// Tani çdo ngarkim i suksesshëm ruhet këtu; kur rrjeti bie, lexohet fotografia
// e fundit dhe app-i hapet i plotë — për lexim. Shkrimi kërkon internet.
//
// KU. IndexedDB (nuk ka kufirin 5 MB të localStorage-it, dhe fotot e
// personave i mban vetë cache-i HTTP i shfletuesit). Nëse IndexedDB mungon
// (shfletues privat, WebView i kufizuar), bie te localStorage — dhe nëse edhe
// ai dështon, thjesht s'ka cache: sjellja e sotme, e paprekur.
//
// ÇELËSAT. Çdo çelës mban familjen ose llogarinë: `fam:<family_id>:people`,
// `acc:<uid>:linked`, `slug:<slug>`. `cacheFshi()` i heq të gjithë te dalja —
// në një telefon të përbashkët pema e tjetrit s'mbetet.
// ─────────────────────────────────────────────────────────────────────────────

const EMRI_DB = "pef-cache";
const DYQANI = "kv";
const PARASHTESA_LS = "pef_cache:";

let dbPromise = null;
function hapDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve) => {
    try {
      if (typeof indexedDB === "undefined") return resolve(null);
      const req = indexedDB.open(EMRI_DB, 1);
      req.onupgradeneeded = () => { req.result.createObjectStore(DYQANI); };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(null);
      req.onblocked = () => resolve(null);
    } catch (_e) { resolve(null); }
  });
  return dbPromise;
}

function kerkese(db, mode, punoj) {
  return new Promise((resolve) => {
    try {
      const tx = db.transaction(DYQANI, mode);
      const st = tx.objectStore(DYQANI);
      const r = punoj(st);
      tx.oncomplete = () => resolve(r && "result" in r ? r.result : undefined);
      tx.onerror = () => resolve(undefined);
      tx.onabort = () => resolve(undefined);
    } catch (_e) { resolve(undefined); }
  });
}

/** Ruaj një vlerë (çdo gjë që JSON-i e mban). Kurrë nuk hedh gabim. */
export async function cacheRuaj(celesi, vlera) {
  const db = await hapDb();
  if (db) {
    await kerkese(db, "readwrite", (st) => st.put({ v: vlera, t: Date.now() }, celesi));
    return;
  }
  try { localStorage.setItem(PARASHTESA_LS + celesi, JSON.stringify({ v: vlera, t: Date.now() })); } catch (_e) { /* s'ka cache */ }
}

/** Lexo një vlerë; `null` kur mungon. */
export async function cacheLexo(celesi) {
  const db = await hapDb();
  if (db) {
    const r = await kerkese(db, "readonly", (st) => st.get(celesi));
    return r && "v" in r ? r.v : null;
  }
  try {
    const raw = localStorage.getItem(PARASHTESA_LS + celesi);
    if (!raw) return null;
    const r = JSON.parse(raw);
    return r && "v" in r ? r.v : null;
  } catch (_e) { return null; }
}

/** Fshi gjithçka (te dalja nga llogaria). */
export async function cacheFshi() {
  const db = await hapDb();
  if (db) await kerkese(db, "readwrite", (st) => st.clear());
  try {
    Object.keys(localStorage).filter((k) => k.startsWith(PARASHTESA_LS)).forEach((k) => localStorage.removeItem(k));
  } catch (_e) { /* asgjë */ }
}

/**
 * A është ky gabim «s'ka rrjet»? Supabase-js e kthen dështimin e fetch-it si
 * `TypeError: Failed to fetch` (Chrome), `Load failed` (Safari/WebView iOS),
 * `NetworkError when attempting to fetch resource` (Firefox). Kur telefoni e
 * di vetë se s'ka lidhje, s'ka nevojë për mesazhin.
 */
export function eshteGabimRrjeti(err) {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  const m = String((err && (err.message || err.details || err)) || "").toLowerCase();
  // SIGURIA2 — WKWebView (iOS) i thotë ndryshe: «The network connection was
  // lost.» / «The request timed out.» / «Could not connect to the server.» /
  // «The Internet connection appears to be offline.» Pa to, kthimi nga sfondi
  // në iOS (kur `navigator.onLine` mbetet true) binte te rruga e gabimeve të
  // tjera në vend të cache-it.
  return m.includes("failed to fetch") || m.includes("load failed") || m.includes("networkerror")
    || m.includes("network request failed") || m.includes("fetch failed") || m.includes("err_internet_disconnected")
    || m.includes("network connection was lost") || m.includes("request timed out")
    || m.includes("could not connect to the server") || m.includes("internet connection appears to be offline");
}
